import { defineStore } from "pinia";

export const usePageErrorStore = defineStore("pageErrorStore", {
    state: () => ({
        status: window.tripper?.error ?? null,
    }),
    actions: {
        set(status) {
            this.status = status;
        },
        clear() {
            this.status = null;
        },
    },
});
